import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shopFilled"
const ShopFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.625 10.058Q17.76 10.234 17.919 10.394C18.587 11.062 19.493 11.437 20.437 11.437Q20.92 11.438 21.376 11.312V20.25C21.375 21.078 20.703 21.75 19.875 21.75H4.125C3.297 21.75 2.625 21.078 2.625 20.25V11.31Q3.081 11.437 3.563 11.438C4.507 11.438 5.413 11.063 6.08 10.395Q6.24 10.234 6.375 10.058 6.51 10.234 6.669 10.394C7.337 11.062 8.243 11.437 9.188 11.437 10.131 11.438 11.038 11.063 11.706 10.395Q11.864 10.234 12 10.058 12.135 10.234 12.294 10.394C12.962 11.062 13.868 11.437 14.812 11.437 15.758 11.438 16.664 11.063 17.333 10.395Q17.488 10.234 17.624 10.058M15 13.125C14.379 13.125 13.875 13.629 13.875 14.25V20.25H18.375V14.25C18.375 13.629 17.871 13.125 17.25 13.125zM6.75 13.125C6.129 13.125 5.625 13.629 5.625 14.25V17.25C5.625 17.871 6.129 18.375 6.75 18.375H10.5C11.121 18.375 11.625 17.871 11.625 17.25V14.25C11.625 13.629 11.121 13.125 10.5 13.125z"
            clipRule="evenodd"
          />
          <path d="M19.317 2.25C19.814 2.25 20.279 2.497 20.557 2.908L22.242 5.388C22.409 5.636 22.5 5.93 22.5 6.231V7.875C22.5 8.422 22.282 8.946 21.896 9.333 21.509 9.72 20.984 9.937 20.437 9.937S19.367 9.72 18.98 9.334C18.593 8.946 18.375 8.422 18.375 7.875H16.875C16.875 8.422 16.657 8.946 16.271 9.333 15.884 9.72 15.359 9.937 14.812 9.937 14.267 9.938 13.742 9.72 13.355 9.334 12.968 8.946 12.75 8.422 12.75 7.875H11.25C11.25 8.422 11.033 8.946 10.646 9.333S9.735 9.937 9.187 9.937C8.64 9.938 8.117 9.72 7.73 9.334S7.125 8.422 7.125 7.875H5.625C5.625 8.422 5.408 8.946 5.021 9.333S4.11 9.937 3.563 9.937C3.015 9.938 2.49 9.72 2.104 9.334S1.5 8.422 1.5 7.875V6.231C1.5 5.93 1.591 5.636 1.76 5.388L3.441 2.908 3.497 2.832C3.779 2.467 4.217 2.25 4.683 2.25z" />
        </svg>
      }
    </span>
  )
}
export default ShopFilledIcon
